module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-300italic.323759b5.eot";